export const WORDLE_TITLE = 'Not Wordle - Bisaya'

export const WIN_MESSAGES = ['Maayo kaayo!', 'Idol!', 'Yati ra!']
export const GAME_COPIED_MESSAGE = 'Nakopya na sa Clipboard'
export const ABOUT_GAME_MESSAGE = 'Unsa ma ni'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Kuwang ug letra'
export const WORD_NOT_FOUND_MESSAGE = 'Di ni pwede bai'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Ang anser: ${solution}`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = '⌫'
export const STATISTICS_TITLE = 'Statistics'
export const GUESS_DISTRIBUTION_TEXT = 'Guess Distribution'
export const NEW_WORD_TEXT = 'Bag-ong duwa sa'
export const SHARE_TEXT = 'Share'
export const TOTAL_TRIES_TEXT = 'Total tries'
export const SUCCESS_RATE_TEXT = 'Success rate'
export const CURRENT_STREAK_TEXT = 'Current streak'
export const BEST_STREAK_TEXT = 'Best streak'
